<template>
  <a-range-picker
    v-model:value="value"
    @change="selectDay"
    :disabled-date="disabledDate"
  />
</template>

<script>
import { defineComponent, ref } from "vue";
import moment, { Moment } from 'moment';

export default defineComponent({
  setup(props, context) {
    const value = ref(null);

    const disabledDate = (current) => {
      return current && current > moment().endOf('day');
    };

    const selectDay = (date, dateString) => {
      context.emit("userPickRangeTime", dateString);
    };

    return {
      selectDay,
      value,
      disabledDate,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
